import React from 'react';
import { colors } from '../utils/colors';
interface MetricsCardProps {
  title: string;
  value: string | number;
  change?: string;
  trend?: 'up' | 'down' | 'neutral';
  icon: React.ReactNode;
  color: string;
}
const MetricsCard: React.FC<MetricsCardProps> = ({
  title,
  value,
  change,
  trend,
  icon,
  color
}) => {
  const getTrendColor = () => {
    if (!trend) return 'text-gray-500';
    return trend === 'up' ? 'text-green-500' : trend === 'down' ? 'text-red-500' : 'text-gray-500';
  };
  // Override the color with our new color scheme
  const bgColor = colors.ui.lightTeal;
  const iconColor = colors.primary.medium;
  return <div className="bg-white rounded-lg shadow p-5" data-id="element-53">
      <div className="flex items-center" data-id="element-54">
        <div className="p-3 rounded-full" style={{
        backgroundColor: bgColor
      }} data-id="element-55">
          <div style={{
          color: iconColor
        }} data-id="element-56">
            {icon}
          </div>
        </div>
        <div className="ml-5" data-id="element-57">
          <p className="text-sm font-medium text-gray-500" data-id="element-58">{title}</p>
          <div className="flex items-baseline" data-id="element-59">
            <p className="text-2xl font-semibold" style={{
            color: colors.primary.dark
          }} data-id="element-60">
              {value}
            </p>
            {change && <p className={`ml-2 text-sm font-medium ${getTrendColor()}`} data-id="element-61">
                {change}
              </p>}
          </div>
        </div>
      </div>
    </div>;
};
export default MetricsCard;